import { Directive, ElementRef, HostBinding, HostListener, Inject, DOCUMENT } from '@angular/core';
import { UIToast, UIToastComponent, UIToastRef } from '@irohalab/deneb-ui';


@Directive({
  selector: '[appCopyOnClick]',
  standalone: true
})
export class CopyOnClickDirective {
  private readonly toastRef: UIToastRef<UIToastComponent>;
  @HostBinding('style.cursor')
  cursor = 'pointer';

  constructor(private el: ElementRef<HTMLInputElement>,
              @Inject(DOCUMENT) private document: Document,
              toast: UIToast) {
    this.toastRef = toast.makeText();
  }

  @HostListener('click')
  onClick(): void {
    this.selectAndCopy();
  }

  private selectAndCopy(): void {
    const inputElement = this.el.nativeElement;

    // Ensure there's a value to copy
    if (!inputElement.value) {
      return;
    }

    // A. Automatically select all text inside the input.
    inputElement.select();
    // For better compatibility with mobile devices.
    inputElement.setSelectionRange(0, 99999);

    // B. Automatically copy the selected text to the clipboard.
    if (navigator.clipboard) {
      navigator.clipboard.writeText(inputElement.value)
        .then(() => {
          // Optional: You can provide user feedback here, like a toast message.
          this.toastRef.show('Text copied to clipboard!');
        })
        .catch(err => {
          this.toastRef.show('Failed to copy text: ' + err);
        });
    } else {
      // Legacy, synchronous approach
      try {
        const successful = this.document.execCommand('copy');
        if (successful) {
          this.toastRef.show('Copied via execCommand!');
        } else {
          this.toastRef.show('Fallback copy unsuccessful.');
        }
      } catch (err) {
        this.toastRef.show('Fallback copy failed: ' + err);
      }
    }
  }
}
